/**
 * MoveOutDialog — Confirmation dialog for moving out (deactivating) a resident.
 */

const MoveOutDialog = ({
  residentName,
  onClose, onConfirm, saving,
}) => {
  return (
    <div className="pp-dialog-backdrop" onClick={onClose}>
      <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="pp-dialog__header">
          <h2 className="pp-dialog__title">Move Out Resident</h2>
          <button className="dp-drawer__close" onClick={onClose}>&#x2715;</button>
        </div>
        <div className="pp-dialog__body">
          <p style={{ margin: 0, lineHeight: 1.6 }}>
            Are you sure you want to move out <strong>{residentName}</strong>?
          </p>
          <p style={{ margin: 'var(--space-2) 0 0', color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)' }}>
            This will deactivate the resident. Their devices and wellness assignments will no longer be active.
            You can move them back in later.
          </p>
        </div>
        <div className="pp-dialog__footer">
          <button className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button className="dp-btn dp-btn--danger" onClick={onConfirm} disabled={saving}>
            {saving ? 'Moving Out\u2026' : 'Move Out'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MoveOutDialog;
